import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import FormField from '../../../components/FormField'
import Select from './Select.js'
import {
  editOrganization,
  selectOrganization,
  showDeleteModal,
  getConnectedCourses,
} from '../actions'

class OrgRow extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      edit: false,
      editOrg: {
        id: this.props.orgId,
        orgName: this.props.orgName,
        contact: this.props.contact,
        providerId: this.props.providerId,
        sfUserId: this.props.sfUserId,
        clientId: this.props.clientId,
        clientSecret: this.props.clientSecret,
        baseUrl: this.props.baseUrl,
      },
    }
  }

  handleOrgChange = event => {
    let {
      target: { name, value },
    } = event
    this.setState({
      editOrg: {
        ...this.state.editOrg,
        [name]: value,
      },
    })
  }

  handleSelect = event => {
    this.setState({
      editOrg: {
        ...this.state.editOrg,
        contact: event.target.value,
      },
    })
  }

  editOrg = () => {
    this.setState(prevState => ({
      edit: !prevState.edit,
    }))
  }

  saveEditOrg = () => {
    this.props.editOrganization(this.state.editOrg)
    this.setState(prevState => ({
      edit: !prevState.edit,
    }))
  }

  deleteOrg = () => {
    this.props.showDeleteModal(this.state.editOrg.id)
  }

  selectOrg = () => {
    this.props.selectOrganization(this.props.orgId)
    this.props.getConnectedCourses(this.props.orgId)
  }

  render() {
    let contactsMap = this.props.myeducatorUsers.reduce((map, user) => {
      map[user.id] = user.email
      return map
    }, {})

    if (!this.state.edit) {
      return (
        <tr>
          <td>{this.props.orgName}</td>
          <td>{contactsMap[this.props.contact]}</td>
          <td>{this.props.providerId}</td>
          <td>{this.props.baseUrl}</td>
          <td>{this.props.sfUserId}</td>
          <td>{this.props.clientId}</td>
          <td>***********</td>
          <td>
            <button onClick={this.editOrg} className="btn btn-primary">
              Edit
            </button>
            <button onClick={this.selectOrg} className="btn btn-warning">
              View
            </button>
          </td>
        </tr>
      )
    } else {
      return (
        <tr>
          <td>
            <FormField
              name="orgName"
              label={null}
              value={this.state.editOrg.orgName}
              handler={this.handleOrgChange}
              type="text"
            />
          </td>
          <td>
            <Select
              user={this.state.editOrg.contact}
              users={this.props.myeducatorUsers}
              handler={this.handleSelect}
            />
          </td>
          <td>
            <FormField
              name="providerId"
              label={null}
              value={this.state.editOrg.providerId}
              handler={this.handleOrgChange}
              type="text"
            />
          </td>
          <td>
            <FormField
              name="baseUrl"
              label={null}
              value={this.state.editOrg.baseUrl}
              handler={this.handleOrgChange}
              type="text"
            />
          </td>
          <td>
            <FormField
              name="sfUserId"
              label={null}
              value={this.state.editOrg.sfUserId}
              handler={this.handleOrgChange}
              type="text"
            />
          </td>
          <td>
            <FormField
              name="clientId"
              label={null}
              value={this.state.editOrg.clientId}
              handler={this.handleOrgChange}
              type="text"
            />
          </td>
          <td>
            <FormField
              name="clientSecret"
              label={null}
              value={this.state.editOrg.clientSecret}
              handler={this.handleOrgChange}
              type="text"
            />
          </td>
          <td>
            <button onClick={this.saveEditOrg} className="btn btn-primary">
              Save
            </button>
            <button onClick={this.deleteOrg} className="btn btn-danger">
              Delete
            </button>
          </td>
        </tr>
      )
    }
  }
}

OrgRow.propTypes = {
  orgId: PropTypes.string,
  orgName: PropTypes.string,
  contact: PropTypes.string,
  providerId: PropTypes.string,
  sfUserId: PropTypes.string,
  clientId: PropTypes.string,
  clientSecret: PropTypes.string,
  baseUrl: PropTypes.string,
  myeducatorUsers: PropTypes.array,
  selectOrganization: PropTypes.func,
  editOrganization: PropTypes.func,
  showDeleteModal: PropTypes.func,
  getConnectedCourses: PropTypes.func,
}

const mapStateToProps = state => {
  return {
    myeducatorUsers: state.myeducatorUsers,
  }
}
const mapDispatchToProps = dispatch => {
  return {
    selectOrganization: selectedOrgId => {
      dispatch(selectOrganization(selectedOrgId))
    },
    editOrganization: orgData => {
      dispatch(editOrganization(orgData))
    },
    showDeleteModal: deleteOrgId => {
      dispatch(showDeleteModal(deleteOrgId))
    },
    getConnectedCourses: selectedOrgId => {
      dispatch(getConnectedCourses(selectedOrgId))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(OrgRow)
